module.exports = __webpack_public_path__ + "img/buy-mobile.f84fd4ad.svg";